module.exports = __webpack_public_path__ + "static/img/25.9d35bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/25.jpg
// module id = HVbb
// module chunks = 0